module.exports = __webpack_public_path__ + "img/dbg2.5cd74bef.jpg";